
import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import DateIcon from "../../../../Shared/components/Icons/Date";
import { Button, Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Row, Col, Space } from "antd";
import clsx from "clsx";
import { idNamingConversion } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";

export const CustomForm = (props) => {
    const { visible, handleClose, createSchedule, changeHandler, form, error, customObject,
        workflowDetails, frequencyDetails, customerApi,
        customerGroupdetails, customerDetails } = props;

    const classes = customStyles();
    return <PrimaryDrawer
        anchor={'right'}
        open={visible}
        variant={'temporary'}
        handleClose={() => handleClose()}
        title={`Run Schedule`}
        width={'495px'}
        className={clsx(classes.closeBackGround, classes.width100P)}
        component={
            <Box
                className={clsx(classes.customForm, classes.removeUnderline)}
                component="form"
                autoComplete="off"
                onSubmit={(e) => createSchedule(e)}>
                <div className={classes.customFormFlex}>
                    <Row type="flex" gutter={40}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div className={clsx(classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.dataOfSchedule}
                                        label="Date of Schedule"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Date of Schedule', 'scheduleTransactions', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                changeHandler(new Date(), 'dataOfSchedule')
                                                : changeHandler(newValue, 'dataOfSchedule')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin30t, classes.typographyHeader, classes.bold)}>Filter By Customer</Typography>
                            <FormControl
                                className={clsx(classes.margin10t, classes.dropDownPointer, classes.customRadioButton)}
                                variant={'standard'}
                                fullWidth>
                                <RadioGroup
                                    row
                                    defaultValue={1}
                                    aria-labelledby="demo-customized-radios"
                                    name="filterBy"
                                    value={form.filterBy}
                                    id={idNamingConversion('Filter By', 'scheduleTransactions', 'Radio')}
                                    onChange={(e) => changeHandler(e)}>
                                    <FormControlLabel value={'ALL'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="All Customers" />
                                    <FormControlLabel value={'GROUP'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Customer Group" />
                                    <FormControlLabel value={'SPECIFIC'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Customer" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.customerLabelNone}>
                            {
                                form?.filterBy === 'GROUP' && <AutoCompleteComponent
                                    customLabel={'Customer Group'}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={customerGroupdetails}
                                    parentValue={customObject(customerGroupdetails, form?.groupId)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    id={idNamingConversion('Customer Group', 'scheduleTransactions', 'DropDown')}
                                    customClasses={classes.margin30t}
                                    onChange={(data) => changeHandler(data.id, 'groupId')}
                                    parentError={error.groupId}
                                />
                            }
                            {
                                form?.filterBy === 'SPECIFIC' && <AutoCompleteComponent
                                    customLabel={'Customer'}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={customerDetails}
                                    id={idNamingConversion('Customer', 'scheduleTransactions', 'DropDown')}
                                    parentValue={customObject(customerDetails, form?.customerId)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    searchType={(s) => customerApi(s)}
                                    customClasses={classes.margin30t}
                                    onChange={(data) => changeHandler(data.id, 'customerId')}
                                    parentError={error.customerId}
                                />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <AutoCompleteComponent
                                customLabel={'Workflow'}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={workflowDetails}
                                parentValue={customObject(workflowDetails, form?.workflowId)}
                                position={"bottom"}
                                id={idNamingConversion('Workflow', 'scheduleTransactions', 'DropDown')}
                                customClasses={classes.margin30t}
                                onChange={(data) => changeHandler(data.id, 'workflowId')}
                            />
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <AutoCompleteComponent
                                customLabel={'Action Frequency'}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={frequencyDetails}
                                parentValue={customObject(frequencyDetails, form?.scheduleFrequencyId)}
                                position={"bottom"}
                                id={idNamingConversion('Action Frequency', 'scheduleTransactions', 'DropDown')}
                                customClasses={classes.margin30t}
                                onChange={(data) => changeHandler(data.id, 'scheduleFrequencyId')}
                            />
                        </Col>
                    </Row>
                </div>
                <div className={clsx(classes.btnParent)}>
                    <Space size={[10, 10]} direction="horizontal" align="center">
                        <Button
                            key="ok"
                            color="primary"
                            variant="contained"
                            type={'submit'}
                            className={clsx(classes.modalBtn)}>
                            OK
                        </Button>
                        <Button
                            key="cancel"
                            color="primary"
                            variant="contained"
                            onClick={() => handleClose()}
                            className={clsx(classes.AddMoreBtn)}
                        >Cancel</Button>
                    </Space>
                </div>
            </Box>
        }
    />
}